import Styles from "../styles/Modules/joinus.module.css";
import "../../src/styles/global.css";
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { resendOtp, sendOtp, verifyOtp } from "../redux/actions/AuthActions";
import OtpInput from "react-otp-input";
import { Input } from "reactstrap";
import swal from 'sweetalert2';
import axios from "axios";
import Multiselect from "multiselect-react-dropdown";
import { fetchSubCategories } from "../redux/actions/ProjectReportAction";
import Header from "../Components/PageComponent/Layout/Header";
import Footer from "../Components/PageComponent/Layout/Footer";

import bannerImg from "../assets/images/banner/supplier-slider.jpg";
import pdfUrl from "../assets/pdf/AFFIDAVIT_Supplier_Franchise_CM Yuva Web Terms.pdf";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Register = () => {
    const dispatch = useDispatch();
    const [formFields, setFormFields] = useState({
        mobile: '',
        name: '',
        email: '',
        sector: '',
        industry: [],
        isChecked: false,
        afidavitCheck: false,
        p_name: '',
        p_video_url: '',
        price: '',
        p_image: null,
        manufactured_by: '',
        location: '',
        description: '',
        profile_image: null,
        brochure: null,
        enterprise_logo: null,
        designation: '',
        total_experience: '',
        business_name: '',
        address: '',
        add_info: '',
        p_industry: '',
        gst_number: '',
        supplier_type: 'Manufacturing',
        key_points: [],
        website: '',
        pincode: '',
        city: '',
        state: '',
        bank_name: '',
        bank_ifsc_code: '',
        bank_branch_name: '',
        bank_account_number: '',
        bank_person_name: '',
    });

    const [newKeyPoint, setNewKeyPoint] = useState('');
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isPersonalDetail, setIsPersonalDetail] = useState(false);
    const [supplierId, setSupplierId] = useState(0);
    const [errors, setErrors] = useState({});
    const [industries, setIndustries] = useState([]);
    const { AuthReducer: { otpLoading, otpVerifiedStatus, errors: reduxErrors } } = useSelector(state => state)

    const { subcategory } = useSelector((state) => state.projectReportReducer);
   
    useEffect(() => {
        dispatch(fetchSubCategories(5));
    }, []);

    useEffect(() => {
        if (formFields.sector == 3267 ) {
            axios.get(`/api/cm-yuva/franchise-sector`)
                .then(res => {
                    setIndustries(res?.data?.franchiseCategories);
                })
                .catch(err => console.log(err))
        }else if(formFields.sector ){
            axios.get(`/api/cm-yuva/get-sub-sub-categories/${formFields.sector}`)
                .then(res => {
                    setIndustries(res?.data?.projectIndustry);
                })
                .catch(err => console.log(err))

        }
    }, [formFields.sector])

    const validateMobile = (mobile) => (mobile && (mobile.length >= 12 && mobile.length <= 15) ? '' : 'Please enter a valid mobile number');
    const validateName = (name) => (name ? '' : 'Name is required');
    const validateEmail = (email) => (email.includes('@') ? '' : 'Please enter a valid email');
    const validateGst = (gst) => {
        const gstRegex = /^[A-Z]{2}[0-9]{10}[A-Z]{1}[0-9]{1}[A-Z0-9]{1}$/i;
        return gstRegex.test(gst) ? '' : 'Please enter a valid GST number';
    };
    const addKeyPoint = () => {
        if (newKeyPoint.trim()) {
            setFormFields(prevState => ({
                ...prevState,
                key_points: [...prevState.key_points, newKeyPoint.trim()],
            }));
            setNewKeyPoint('');
        }
    };
    const removeKeyPoint = (index) => {
        const updatedKeyPoints = formFields.key_points.filter((_, i) => i !== index);
        setFormFields(prevState => ({
            ...prevState,
            key_points: updatedKeyPoints,
        }));
    };
    const notify = (message, type) => {
        swal.fire({
            show: true,
            //    title: "Well done!",
            text: message,
            icon: type,
            showConfirmButton: false,
            timer: 1500,
        });
    };
    const handleInputChangeOld = (e) => {
        const { name, value } = e.target;
        if (type === "file") {
            return { ...prev, [name]: files[0] };
        }

        else {
            setFormFields((prev) => ({ ...prev, [name]: value }));
        }
        if (errors[name]) {
            const newErrors = { ...errors };
            delete newErrors[name];
            setErrors(newErrors);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;

        setFormFields((prev) => {
            if (type === "file") {
                return { ...prev, [name]: files[0] };
            }

            return { ...prev, [name]: value };
        });

        if (errors[name]) {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const handleMobileChange = (value) => {
        setFormFields((prev) => ({ ...prev, mobile: value }));
        if (errors.mobile) {
            const newErrors = { ...errors };
            delete newErrors.mobile;
            setErrors(newErrors);
        }
    };

    const handleOTPChange = (value) => {
        if (!isNaN(value)) {
            setOtp(value);
            if (value.length === 4) dispatch(verifyOtp(formFields.mobile, value));
        }
    };
    const handleSendOtp = () => {
        const mobileError = validateMobile(formFields.mobile);
        if (mobileError) {
            setErrors({ mobile: mobileError });
            return;
        }
        notify("OTP Sent Successfully", "success");
        dispatch(sendOtp(formFields.mobile));
        setIsOtpSent(true);
    };
    const handleVerifyOtp = () => {
        if (otp.length === 4 && !isNaN(otp)) {
            dispatch(verifyOtp(formFields.mobile, otp));
            if (otpVerifiedStatus === false) {
                notify("Invalid OTP", "error");
                setErrors({ otp: "Enter valid OTP" });
            } else {
                setErrors({ otp: "" });
            }
        } else {
            notify("Invalid OTP", "error");
            setErrors({ otp: "Enter valid OTP" });
        }
    };
    const handleResendOtp = () => {
        notify("OTP Resent Successfully", "login-resent-otp-success");
        dispatch(resendOtp(formFields.mobile));
    };
    const handlePinCodeChange = (e) => {
        const { value } = e.target;
        if (value.length <= 6) {
            const isValid = /^[0-9]{0,6}$/.test(value);
            if(!isValid) return;
            setFormFields((prev) => ({ ...prev, pincode: value }));
        }

        if (value.length === 6) {
            axios.get(`https://api.postalpincode.in/pincode/${value}`).then(
                (res) => {
                    if (res.data[0].Status === "Success") {
                        setFormFields((prev) => ({ ...prev, city: res.data[0].PostOffice[0].Block, state: res.data[0].PostOffice[0].State }));
                    }
                }
            );
        } else {
            setFormFields((prev) => ({ ...prev, city: "", state: "" }));
        }
    };
    const handleCheckboxChange = () => {
        setFormFields((prev) => ({ ...prev, isChecked: !formFields.isChecked }));
    };
    const handleCheckboxChangeAfidavit = () => {
        setFormFields((prev) => ({ ...prev, afidavitCheck: !formFields.afidavitCheck }));
    };
    const handleSubmit = async () => {
        const newErrors = {};
        const nameError = validateName(formFields.name);
        const emailError = validateEmail(formFields.email);
        const mobileError = validateMobile(formFields.mobile);
        // const gstError = validateGst(formFields.gst_number);

        if (!formFields.password) newErrors.password = 'Password is required';
        if (!formFields.sector) newErrors.sector = 'Sector is required';
        if (formFields.industry.length === 0) newErrors.industry = 'At least one industry is required';
        if (!formFields.city) newErrors.city = 'City is required';
        if (!formFields.add_info) newErrors.add_info = 'Additional information is required';
        if (!formFields.state) newErrors.state = 'State is required';
        if (!formFields.pincode || formFields.pincode.length !== 6) newErrors.pincode = 'Please enter a valid 6-digit pincode';
        // if (!formFields.website) newErrors.website = 'Website URL is required';
        if (!formFields.business_name) newErrors.business_name = 'Business Name is required';
        if (!formFields.isChecked) newErrors.isChecked = 'Please check this to submit Form';
        if (!formFields.afidavitCheck) newErrors.afidavitCheck = 'Please Read and then this to submit Form';
        // if (!formFields.gst_percentage && (formFields.gst_percentage < 0 || formFields.gst_percentage > 100)) newErrors.gst_percentage = 'GST Percentage cannot be greater than 100';

        if (nameError) newErrors.name = nameError;
        if (emailError) newErrors.email = emailError;
        if (mobileError) newErrors.mobile = mobileError;
        // if (gstError) newErrors.gst_number = gstError;

        if (!otpVerifiedStatus) {
            newErrors.otp = 'Please verify your mobile number';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const formData = new FormData();
        Object.keys(formFields).forEach(key => {
            if (key === 'industry') {
                formFields[key].forEach((industry, index) => {
                    formData.append(`industry[${index}]`, industry);
                });
            } else if (key === 'profile_image' || key === 'brochure' || key === 'enterprise_logo' || key === 'signature') {
                if (formFields[key]) {
                    formData.append(key, formFields[key]);
                }
            } else {
                formData.append(key, formFields[key]);
            }
        });
        if (formFields.key_points.length > 0) {
            formFields.key_points.forEach(s => {
                formData.append('key_points[]', s);
            });
        } else {
            formData.append('key_points[]', "");
        }
        formData.append('affidavit_check', (formFields?.afidavitCheck)?1:0);
        formData.append('step', "addPersonalDetails");

        try {
            const response = await axios.post('/api/supplier/add-supplier', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setSupplierId(response?.data?.supplier_id);
            if (response?.data?.success) {
                notify(response?.data?.message, 'success');
                setIsPersonalDetail(false);
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else {
                notify('Form submitted successfully', 'success');
            }
            setIsPersonalDetail(true);
            setTimeout(() => {
                window.location.reload();
            }, 1500);

        } catch (error) {
            notify('Failed to submit form', 'error');
            console.error('Submission error:', error);
        }
    };

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1024 },
            items: 1,
        },
        desktop: {
            breakpoint: { max: 1024, min: 768 },
            items: 1,
        },
        tablet: {
            breakpoint: { max: 768, min: 464 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };

    const desktop_images = [
        "../assets/images/banner/supplier-slider.jpg"
    ];
    const mobile_images = [
        "images/cm_yuva/mobile-supplier-slider.jpg"
    ];
    return (
        <>
            <Header />




            <main className="block-main bg-white">

                {/* <Carousel
                    responsive={responsive}
                    infinite={false}
                    autoPlay={false}
                    autoPlaySpeed={3000}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                    className="d-sm-block d-none"
                >
                  

                    <div className="">
                        <a href="javascript:void(0)" download={true}>
                            <img src={bannerImg} alt={`Slide 1`} style={{ width: "100%", height: "auto" }} />
                        </a>
                    </div>

                </Carousel> */}

                <div className='py-3 bg-gra3 '>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-6 d-flex flex-column align-items-center align-items-md-start'>
                                <span className="hd-2 text-white"><span style={{ color: 'rgb(246, 189, 96)' }}>Become </span>Part of CMYUVA</span>
                                <p className="hd-3 text-white p-0 ">Register as Supplier or Franchise and Join our Network</p>
                            </div>
                            {/* <div className='col-md-6 d-flex flex-column align-items-center align-items-md-end'>
                                <div className="h-100 d-flex align-items-center justify-content-end gap-2">
                                    <a
                                        href={{
                                            pathname: "/ideation/supplier-connect"
                                        }}
                                        passHref
                                    >
                                        <button
                                            type="button"
                                            className="round-btn ro-btn-theme border-0"
                                        >
                                            <span><FaList /></span>
                                            View Supplier List
                                        </button>
                                    </a>

                                    <a
                                        href='https://cmyuva-supplier.iid.org.in/'
                                        passHref
                                    >
                                        <button
                                            type="button"
                                            className="round-btn ro-btn-white border-0"
                                        >
                                            <span><FaUser /></span>
                                            Register as Supplier
                                        </button>
                                    </a>

                                </div>

                            </div> */}
                        </div>
                    </div>

                </div>

                <div className="mt-4">

                    <div className="common-section pt-4">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-12 align-self-start">
                                    <div className="block-login-form mb-0">
                                        {/* <h4 className="f-le-main-title row">
                                            Join our Consultancy network, disburse your knowledge and grow with us.
                                        </h4> */}
                                        <div className="row form-legend">
                                            <h4 className="legend-title bg-gra1">Enter your details below</h4>
                                            <div className="col-md-4 mb-3">
                                                <label className="">Mobile Number</label>
                                                <PhoneInput
                                                    country={"in"}
                                                    value={formFields.mobile}
                                                    onChange={handleMobileChange}
                                                    maxLength={15}
                                                    containerClass={Styles.phone_input_container}
                                                    disabled={isOtpSent ? true : false}
                                                    inputClass={`${Styles.phone_input} ${errors.mobile ? 'is-invalid' : ''}`}
                                                />
                                            </div>

                                            {!isOtpSent && (
                                                <div className="col-4 d-flex align-items-center">
                                                    <button className="theme-outline-btn bg-gra1 text-white border-0 m-0" onClick={handleSendOtp}>
                                                        Send OTP
                                                    </button>
                                                </div>
                                            )}
                                            {errors.mobile && <div className="col-12 invalid-feedback text-danger d-block">{errors.mobile}</div>}


                                            {isOtpSent && !otpVerifiedStatus && (
                                                <div className="form-group col-md-8">
                                                    <div className="row">
                                                        <label className="mb-3">Enter OTP</label>
                                                        <div className="col-sm-5">
                                                            <OtpInput
                                                                value={otp}
                                                                numInputs={4}
                                                                separator={<span className="me-2 ms-2">*</span>}
                                                                onChange={handleOTPChange}
                                                                inputStyle={{
                                                                    width: "100%",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #000",
                                                                    height: "38px",
                                                                }}
                                                                renderInput={(props) => <input {...props} />}

                                                            />
                                                        </div>


                                                        <div className="col-sm-6 mt-3 mt-sm-0">
                                                            {!otpVerifiedStatus && isOtpSent && (
                                                                <a
                                                                    className="theme-outline-btn bg-success text-white border-0 m-0"
                                                                    onClick={handleResendOtp}
                                                                >
                                                                    {otpLoading ? "Loading..." : "Resend OTP"}
                                                                </a>
                                                            )}
                                                            <button className="theme-outline-btn bg-gradient-style text-white border-0" onClick={handleVerifyOtp}>
                                                                Verify OTP
                                                            </button>
                                                        </div>

                                                        <div className="col-12">
                                                            {errors.otp && <div className="invalid-feedback text-danger d-block">{errors.otp}</div>}
                                                        </div>


                                                    </div>
                                                </div>
                                            )}


                                            <div className="row">

                                                <div className="form-group col-md-6">
                                                    <label className="">Password<span className="text-danger">*</span></label>
                                                    <input
                                                        type="password"
                                                        name="password"
                                                        disabled={!otpVerifiedStatus}
                                                        value={formFields.password}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.password && <div className="invalid-feedback text-danger d-block">{errors.password}</div>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="form-group col-md-6">
                                                    <label>Name<span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        value={formFields.name}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.name && <div className="invalid-feedback text-danger d-block">{errors.name}</div>}
                                                </div>
                                                <div className="form-group  col-md-6">
                                                    <label>Email<span className="text-danger">*</span></label>
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        value={formFields.email}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.email && <div className="invalid-feedback text-danger d-block">{errors.email}</div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-4">
                                                    <label>Designation</label>
                                                    <input
                                                        type="text"
                                                        name="designation"
                                                        value={formFields.designation}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.designation ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.designation && <div className="invalid-feedback text-danger d-block">{errors.designation}</div>}
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label>Total Experience</label>
                                                    <input
                                                        type="text"
                                                        name="total_experience"
                                                        value={formFields.total_experience}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.total_experience ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.total_experience && <div className="invalid-feedback text-danger d-block">{errors.total_experience}</div>}
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label>Business Name<span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="business_name"
                                                        value={formFields.business_name}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.business_name ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.business_name && <div className="invalid-feedback text-danger d-block">{errors.business_name}</div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-4">
                                                    <label>Select Sector<span className="text-danger">*</span></label>
                                                    <select
                                                        name="sector"
                                                        value={formFields.sector}
                                                        disabled={!otpVerifiedStatus}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.sector ? 'is-invalid' : ''}`}
                                                    >
                                                        <option value="">Select Sector</option>
                                                        {subcategory?.map?.((item) => {
                                                            return (
                                                                <option value={item?.id} key={item.id}>
                                                                    {item?.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                    {errors.sector && <div className="invalid-feedback text-danger d-block">{errors.sector}</div>}
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label>Select Industry<span className="text-danger">*</span></label>
                                                    <Multiselect
                                                        displayValue="name"
                                                        options={industries}
                                                        onSelect={(select) =>
                                                        {
                                                            setFormFields((prev) => ({
                                                                ...prev,
                                                                industry: select.map(item => item.id)
                                                            }))}

                                                        }
                                                        className="bg-white"
                                                        selectedValues={formFields.industry ? industries?.filter(ind => formFields.industry.includes(ind.value)) : []}
                                                        selectionLimit={5}
                                                    />
                                                    {errors.industry && <div className="invalid-feedback text-danger d-block">{errors.industry}</div>}

                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label>Supplier Type<span className="text-danger">*</span></label>
                                                    <select
                                                        name="supplier_type"
                                                        value={formFields.supplier_type}
                                                        disabled={!otpVerifiedStatus}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.supplier_type ? 'is-invalid' : ''}`}
                                                    >
                                                        <option value="Manufacturing">Manufacturing</option>
                                                        <option value="Service">Service</option>
                                                        <option value="Franchise">Franchise</option>
                                                        <option value="Business on Wheels">Business on Wheels</option>
                                                    </select>
                                                    {errors.supplier_type && <div className="invalid-feedback text-danger d-block">{errors.supplier_type}</div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-4">
                                                    <label>Pincode<span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="pincode"
                                                        disabled={!otpVerifiedStatus}
                                                        value={formFields.pincode}
                                                        onChange={(e) => handlePinCodeChange(e)}
                                                        className={`form-control ${errors.pincode ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.pincode && <div className="invalid-feedback text-danger d-block">{errors.pincode}</div>}
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label>City<span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="city"
                                                        value={formFields.city}
                                                        disabled={!otpVerifiedStatus}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.city ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.city && <div className="invalid-feedback text-danger d-block">{errors.city}</div>}
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label>State<span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="state"
                                                        value={formFields.state}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.state ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.state && <div className="invalid-feedback text-danger d-block">{errors.state}</div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-6">
                                                    <label>Address</label>
                                                    <input
                                                        type="text"
                                                        name="address"
                                                        value={formFields.address}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.address && <div className="invalid-feedback text-danger d-block">{errors.address}</div>}
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>GST Number</label>
                                                    <input
                                                        type="text"
                                                        name="gst_number"
                                                        value={formFields.gst_number}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.gst_number ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.gst_number && <div className="invalid-feedback text-danger d-block">{errors.gst_number}</div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-3">
                                                    <label>Profile Image</label>
                                                    <input
                                                        type="file"
                                                        name="profile_image"
                                                        disabled={!otpVerifiedStatus}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.profile_image ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.profile_image && <div className="invalid-feedback text-danger d-block">{errors.profile_image}</div>}
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Brochure</label>
                                                    <input
                                                        type="file"
                                                        name="brochure"
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.brochure ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.brochure && <div className="invalid-feedback text-danger d-block">{errors.brochure}</div>}
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Enterprise Logo</label>
                                                    <input
                                                        type="file"
                                                        name="enterprise_logo"
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.enterprise_logo ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.enterprise_logo && <div className="invalid-feedback text-danger d-block">{errors.enterprise_logo}</div>}
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Signature</label>
                                                    <input
                                                        type="file"
                                                        name="signature"
                                                        // value={formFields.signature}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.signature ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.signature && <div className="invalid-feedback text-danger d-block">{errors.signature}</div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-4">
                                                    <label>Remark</label>
                                                    <Input
                                                        type="textarea"
                                                        className="form-control form-control-sm py-2"
                                                        name="remark"
                                                        value={formFields.remark}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                    />
                                                    {errors.remark && <div className="invalid-feedback text-danger d-block">{errors.remark}</div>}
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label>Website URL</label>
                                                    <input
                                                        type="text"
                                                        name="website"
                                                        value={formFields.website}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.website ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.website && <div className="invalid-feedback text-danger d-block">{errors.website}</div>}
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label>Additional Information</label>
                                                    <input
                                                        type="text"
                                                        name="add_info"
                                                        value={formFields.add_info}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.add_info ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.add_info && <div className="invalid-feedback text-danger d-block">{errors.add_info}</div>}
                                                </div>
                                            </div>
                                            <div className="row align-items-center">
                                                <div className="form-group col-md-4">
                                                    <label>Add Key Points</label>
                                                    <Input
                                                        type="text"
                                                        value={newKeyPoint}
                                                        name='key_points'
                                                        onChange={(e) => setNewKeyPoint(e.target.value)}
                                                        placeholder="Add a key point"
                                                        disabled={!otpVerifiedStatus}
                                                    />
                                                    {errors.key_points && <div className="invalid-feedback text-danger d-block">{errors.key_points}</div>}
                                                </div>
                                                <div className="col-md-2 d-flex align-items-center">
                                                    <button className="theme-outline-btn bg-gradient-style text-white border-0 m-0 w-100" onClick={addKeyPoint}>
                                                        Add
                                                    </button>
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="fw-bold mb-1">Added Key Points</label>
                                                    <table className="table table-sm table-bordered border-dark">
                                                        <thead>
                                                            <tr>
                                                                <th className="col">S. no.</th>
                                                                <th className="col ">Key Point</th>
                                                                <th className="col">Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formFields.key_points.map((point, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{point}</td>
                                                                    <td>
                                                                        <button type="button" className="btn-sm btn-danger" onClick={() => removeKeyPoint(index)}>
                                                                            Remove
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>
                                            <div className="row">

                                                <div className="form-group col-md-3">
                                                    <label>Bank Name</label>
                                                    <input
                                                        type="text"
                                                        name="bank_name"
                                                        value={formFields.bank_name}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.bank_name ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.bank_name && <div className="invalid-feedback text-danger d-block">{errors.bank_name}</div>}
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Bank IFCS Code</label>
                                                    <input
                                                        type="text"
                                                        name="bank_ifsc_code"
                                                        value={formFields.bank_ifsc_code}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.bank_ifsc_code ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.bank_ifsc_code && <div className="invalid-feedback text-danger d-block">{errors.bank_ifsc_code}</div>}
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Bank Branch Name</label>
                                                    <input
                                                        type="text"
                                                        name="bank_branch_name"
                                                        value={formFields.bank_branch_name}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.bank_branch_name ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.bank_branch_name && <div className="invalid-feedback text-danger d-block">{errors.bank_branch_name}</div>}
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Bank Account Number</label>
                                                    <input
                                                        type="text"
                                                        name="bank_account_number"
                                                        value={formFields.bank_account_number}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.bank_account_number ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.bank_account_number && <div className="invalid-feedback text-danger d-block">{errors.bank_account_number}</div>}
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Bank Person Name</label>
                                                    <input
                                                        type="text"
                                                        name="bank_person_name"
                                                        value={formFields.bank_person_name}
                                                        onChange={handleInputChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className={`form-control ${errors.bank_person_name ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.bank_person_name && <div className="invalid-feedback text-danger d-block">{errors.bank_person_name}</div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group">
                                                    <input
                                                        type="checkbox"
                                                        checked={formFields.isChecked}
                                                        name="isChecked"
                                                        onChange={handleCheckboxChange}
                                                        disabled={!otpVerifiedStatus}
                                                        className="me-2 "
                                                    />
                                                    <span>
                                                        I authorize CMYUVA and its representative to contact me with updates and notifications via Email, SMS, Whatsapp and Call. This will override and registry on DND/NDNC.
                                                    </span>
                                                    {errors.isChecked && <div className="invalid-feedback text-danger d-block">{errors.isChecked}</div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group">
                                                    <input
                                                        type="checkbox"
                                                        checked={formFields.afidavitCheck}
                                                        name="afidavitCheck"
                                                        onChange={handleCheckboxChangeAfidavit}
                                                        disabled={!otpVerifiedStatus}
                                                        className="me-2 "
                                                    />
                                                    <a href={pdfUrl} target="_blank"  >
                                                    <span className="text-primary">
                                                        I hereby agree and submit my self-declaration.
                                                    </span></a>
                                                    {errors.afidavitCheck && <div className="invalid-feedback text-danger d-block">{errors.afidavitCheck}</div>}
                                                </div>
                                            </div>
                                            <div className="row d-flex justify-content-center">
                                                <div className="col-md-3 p-0">
                                                    <button className="btn btn-success bg-gra2 border-0 w-100" disabled={!otpVerifiedStatus} onClick={handleSubmit}>
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </main>
            <Footer />
        </>
    );
};

export default Register;
